import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import styles from './index.module.scss'
import { formatTimestamp } from '../../../../../utils/format'

interface IProps {
  reserveCapacitiesList?: any
  serviceOrderReserveDetails?: any
}

export default function Calendar({
  reserveCapacitiesList = [],
  serviceOrderReserveDetails = {},
}: IProps) {
  const { orderId } = useParams() as any
  const [selectedDate, setSelectedDate] = useState('')
  const [customerInfoList, setCustomerInfoList] = useState<any>([])
  const [preList, setPreList] = useState([])
  const [displayMonth, setDisplayMonth] = useState<string>('')
  const [displayYear, setDisplayYear] = useState<string>('')
  const [monthList, setMonthList] = useState<any>([])
  const [monthIndex, setMonthIndex] = useState<number>(0)

  const WEEK_DAY = ['日', '一', '二', '三', '四', '五', '六']

  useEffect(() => {
    handleDate()
  }, [])

  const handleClickDateItem = (dateItem) => {
    setSelectedDate(dateItem.date)
    if (serviceOrderReserveDetails[dateItem.id]) {
      setCustomerInfoList(serviceOrderReserveDetails[dateItem.id])
    } else {
      setCustomerInfoList([])
    }
  }

  const handleDate = () => {
    const copyData = [...reserveCapacitiesList]
    if (copyData?.length > 0) {
      // 获取当前订单对应的预约用户
      const matchDate = getDefaultDate() 
      const firstDate = copyData[0]['date']
      const lastDate = copyData[copyData.length - 1]['date']
      const firstDateMonth = +formatTimestamp(firstDate).slice(5, 7)
      const lastDateMonth = +formatTimestamp(lastDate).slice(5, 7)

      setDisplayMonth(formatTimestamp(matchDate || firstDate).slice(5, 7))
      setDisplayYear(formatTimestamp(matchDate || firstDate).slice(0, 4))

      let monthArr: any = []
      if (firstDateMonth === lastDateMonth) {
        monthArr.push(firstDateMonth)
        setMonthList(monthArr)
      } else {
        for (let i = firstDateMonth; i <= lastDateMonth; i++) {
          monthArr.push(i)
        }
        setMonthList(monthArr)
      }

      handleWeekdayPad(0, monthArr)
    }
  }
  const handleSwitchMonth = (direction: boolean) => {
    let tmp: number = monthIndex
    
    if (direction && tmp < monthList.length - 1) {
      if (monthList[tmp] > monthList[tmp + 1]) {
        let tmpYear: string = '' + (parseInt(displayYear) + 1)
        setDisplayYear(tmpYear)
      }
      tmp = monthIndex + 1
      setDisplayMonth(monthList[tmp])
      setMonthIndex(tmp)

      handleWeekdayPad(tmp)

    }

    if (!direction && tmp > 0) {
      if (monthList[tmp] < monthList[tmp - 1]) {
        let tmpYear: string = '' + (parseInt(displayYear) - 1)
        setDisplayYear(tmpYear)
      }
      tmp = monthIndex - 1
      setDisplayMonth(monthList[tmp])
      setMonthIndex(tmp)

      handleWeekdayPad(tmp)
    }
  }

  const handleWeekdayPad = (index : number, monthArr = monthList) => {
    const dayMatch = reserveCapacitiesList.find(item => formatTimestamp(item.date).slice(5, 7) == monthArr[index])
    if(dayMatch) {
      const firstDateWeekday = +dayjs(dayMatch.date).format('d')
      let preArr: any = []
      for (let i = 0; i < firstDateWeekday; i++) {
        preArr.push({})
      }
      setPreList(preArr)
    }
  }

  const getDefaultDate = () => {
    let matchId : number | null = null
    for (const planId in serviceOrderReserveDetails) { 
      serviceOrderReserveDetails[planId].map(order => {
        if(order.orderId === Number(orderId)) {
          matchId = Number(planId)
          setCustomerInfoList(serviceOrderReserveDetails[planId])
          return
        }
      })
    }
    
    if(matchId) {
      const matchPlanItem = reserveCapacitiesList.find(item => item.id === matchId)

      if(matchPlanItem) {
        setSelectedDate(matchPlanItem.date)
        return matchPlanItem.date
      }
    }

    return null
  }

  return (
    <div className={styles.reserveWrap}>
      <div className={styles.boardTop}>
        <div className={styles.boardTitle}>预约看板</div>
        <div className={styles.selectDateContainer}>
          {monthList.length > 1 && (
            <div
              className={[
                styles.left,
                `${monthIndex === 0 ? styles.disabled : ''}`,
              ].join(' ')}
              onClick={() => handleSwitchMonth(false)}
            ></div>
          )}
          <div className={styles.selectDate}>
            {displayYear && displayMonth && (
              <span>
                {displayYear} 年 {displayMonth} 月
              </span>
            )}
          </div>
          {monthList.length > 1 && (
            <div
              className={[
                styles.right,
                `${monthIndex === monthList.length - 1 ? styles.disabled : ''}`,
              ].join(' ')}
              onClick={() => handleSwitchMonth(true)}
            ></div>
          )}
        </div>
      </div>

      <div className={styles.weekTitle}>
        {WEEK_DAY.map((item, index) => {
          return (
            <div className={styles.weekTitleItem} key={index}>
              {item}
            </div>
          )
        })}
      </div>

      <div className={styles.dateBlock}>
        {Object.keys(preList).length > 0 &&
          preList.map((item, index) => {
            return (
              <div
                className={styles.dateItemContainer}
                key={'dateIndex' + index}
              ></div>
            )
          })}
        {reserveCapacitiesList
          .filter(
            (item) => formatTimestamp(item.date).slice(5, 7) == displayMonth
          )
          .map((dateItem, dateIndex) => {
            return (
              <div
                className={styles.dateItemContainer}
                key={'dateIndex' + dateIndex}
                onClick={() => handleClickDateItem(dateItem)}
              >
                <div
                  className={[
                    styles.date,
                    selectedDate == dateItem.date
                      ? styles.chosen
                      : styles.unchosen,
                  ].join(' ')}
                >
                  <span> {formatTimestamp(dateItem.date).slice(8, 10)}</span>
                </div>

                <div
                  className={
                    dateItem.reserveCan === 0 ? styles.full : styles.notFull
                  }
                >
                  {dateItem.reserveThreshold - dateItem.reserveCan}/
                  {dateItem.reserveThreshold}
                </div>
              </div>
            )
          })}
      </div>
      <div className={styles.customerWrap}>
        {customerInfoList.length > 0 ? (
          customerInfoList.map((item, index) => {
            return (
              <>
                <div
                  className={[
                    styles.infoBox,
                    item.orderId == orderId ? styles.selected : '',
                  ].join(' ')}
                  key={index}
                >
                  <div
                    className={[
                      styles.name,
                      `${item.orderId == orderId ? styles.selected : ''}`,
                    ].join(' ')}
                  >
                    {item.reserveName}
                  </div>
                  {!item.confirmed ? (
                    <div
                      className={[
                        styles.time,
                        `${item.orderId == orderId ? styles.selected : ''}`,
                      ].join(' ')}
                    >
                      未确认
                    </div>
                  ) : (
                    <div
                      className={[
                        styles.time,
                        `${item.orderId == orderId ? styles.selected : ''}`,
                      ].join(' ')}
                    >
                      {item.reserveBeginTime.slice(-8, -3)}-
                      {item.reserveEndTime.slice(-8, -3)}
                    </div>
                  )}
                </div>
              </>
            )
          })
        ) : (
          <div className={styles.emptyTip}>暂无预约</div>
        )}
      </div>
    </div>
  )
}
